<template><svg class="oa-flow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" v-html="markup" /></template>
<script>
import {ICONS} from '@/utils/oaIcons'
export default{name:'OaTypeIcon',props:{name:String},computed:{markup(){return ICONS[this.name]||ICONS.generic}}}
</script>
<style scoped>.oa-flow-icon{display:inline-block;vertical-align:middle;width:1em;height:1em;flex:none;overflow:visible}</style>
